import { defaultSortActivityMode, SortActivityMode } from 'app/shared/models';

export interface MultiUserPreferences {
    recentActivityNumbers: number[];
    recentEmployeeNumbers: number[];
    recentProductBoxNumber: number;
    sortActivityMode: SortActivityMode;
}

export const defaultMultiUserPreferences: MultiUserPreferences = {
    recentActivityNumbers: [],
    recentEmployeeNumbers: [],
    recentProductBoxNumber: -1,
    sortActivityMode: defaultSortActivityMode,
};
